import React, { useContext, useEffect, useRef, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Navigation, Pagination, Controller } from 'swiper';
import {ButtonContainer, ButtonContent} from '../Button';
import { SelectField } from "../Form/";
import {Col, Row} from '../Grid';
import 'swiper/swiper-bundle.min.css';
import 'swiper/swiper.min.css';

import Colors from "constants/Colors";

import { Field } from "formik";
import {
 Carrossel,
 Item,
 ItemHead,
 ItemBody,
 Container,
 ItemSummary,
 ItemCoverages,
 CoverageItem,
 CoverageTitle,
 CoverageBody,
 BulletSlide,
 Title,
 SubTitle,
 CoveragesContainer,
 ItemCoverageHead,
 EditButton,
 DeductibleContainer,
 ExtraText
} from './styles';
import { 
  SmallTitle,
  TitleAlter,
  RowValue,
  InlineLabel 
} from '../Table/styles';
import { Label, CheckBox, Button, FormSection, HasPermission, InputField } from '@fitinsur/components';
import MasksHelper from 'utils/src/masks';
import { GlobalAuthContext, GlobalLoaderContext } from 'store/context';
import Icon from 'components/Icon';
import Card from 'components/Card';
import { forEach } from 'lodash';

const MobileTable = ({
  calcList,
  history,
  idOperation,
  idProduct,
  formikValues,
  disabled,
  permissions,
  onRecalculate,
  handleCheckCoverage,
  onRecalculateItem,
  onConfirmPlanText,
  onConfirmPlan,
  disabledCommision,
  selectedOption,
  openHistoryModel,
  disabledConfirm,
  readOnlyMode,
  showHistory,
  showCoveragesAndExtensions,
  onOptionsDeductible,
  onSelectDeductible,
  onChoosedDeductible,
  hasCoverageCalc,
  showAlterButton,
  warrantyQuote,
  minComission,
  maxComission,
  isInAnalysis,
  newDisabled,
  customButton,
  creditLimits
}) => {
  
  const maskHelper = new MasksHelper();
  const authContext = useContext(GlobalAuthContext);
  const [coverage, setCoverage] = useState([])
  const [option, setOption] = useState(selectedOption != null ? selectedOption : null);
  const [expanded, setExpanded] = useState(readOnlyMode);
  const [productPlanName, setProductPlanName] = useState(null);
  const [collapseCoverages, setCollapseCoverages] = useState([]);
  const parseNumber = (value) => {
    if (typeof (value) === 'string') {
      if (value.startsWith('%')) return Number(value.replaceAll('%', '').replaceAll(',', '.'))

      return Number(value.replaceAll('R$', '').replaceAll('.', '').replaceAll(',', '.'))
    }
    return value
  }

  SwiperCore.use([Navigation, Pagination]);
   const formikKey = readOnlyMode ? 'previousCalculationList' : 'calculationList'

  const renderBullet = (index, className) => {
    return <BulletSlide> {(index + 1)} </BulletSlide>
  };

  const currencyMask = (maxValue) => ({
    "type": "currency",
    "mask": 0,
    "scale": 2,
    "signed": false,
    "normalizeZeros": false,
    "padFractionalZeros": true,
    "radix": ",",
    "thousandsSeparator": ".",
    "mapToRadix": [
      ".",
      ","
    ],
    "max": maxValue || 999999999999999,
    "min": 0
  })

  const groupCoverageItems = () => {
    if (!calcList[0].coverageItems?.length) return;

    const arrCoverage = coverage
    calcList.map(calcListItems => {
      setProductPlanName(calcListItems.productPlanName)
      calcListItems.coverageItems.map(item => {
        arrCoverage.push(item)
      })
    });
    const filterCoverageItems = Array.from(new Set(arrCoverage.map(a => a.idProductCoverage)))
      .map(id => {
        return arrCoverage.find(a => a.idProductCoverage === id)
      })

    setCoverage(filterCoverageItems)
  }

  const handleCollapseCoverages = (index) => {
    const tempCollapse = collapseCoverages;
    tempCollapse[index] = !collapseCoverages[index];
    setCollapseCoverages(() => [...tempCollapse]);
  };

  const showOption = (index) => {
    if (!expanded) {
      setOption(index);
      setExpanded(true)
    } else {
      setOption(null);
      setExpanded(false)
    }

  };

  useEffect(() => {
    if (calcList.length) {
      groupCoverageItems();

      forEach(calcList, (item, index) => {
        setCollapseCoverages((collapseCoverages) => {
          return [...collapseCoverages, true];
        })
      })
    }
  }, [calcList]);

  const handleIcons = (index, covIndex) => formikValues?.calculationList[index].coverageItems[covIndex]?.coverageDisabled ? <Icon name='close-red' /> : <Icon name='check' />

  const modalityCreditLimit = creditLimits?.find(
    item => item?.idProductPlan === calcList[0]?.idProductPlan
  );

  const borrowerCreditLimit = creditLimits?.find(
    item => !item?.idProductPlan
  );

  return (
    <Container>

      {(hasCoverageCalc && onOptionsDeductible.length) &&
        <DeductibleContainer>
          <Field
            style={{ width: '100%', margin: 'auto' }}
            component={SelectField}
            disabled={readOnlyMode || disabledCommision}
            options={onOptionsDeductible}
            name='optionDeductible'
            value={formikValues.optionDeductible}
            hidePlaceholder
            label='Selecione a franquia:'
            onChange={value => onSelectDeductible && onSelectDeductible(value)}
          />
        </DeductibleContainer>
      }
      <Carrossel>
        <Swiper
          slidesPerView={1}
          spaceBetween={50}
          centeredSlides
          modules={[Pagination]}
          pagination={{
            clickable: true,
          }}
          onSlideChange={({activeIndex}) => {
            setCollapseCoverages([true, true, true]);
            setOption(activeIndex);
          }}
        >
        {calcList.map((calcListItems, index) => {
          const coverageCalc = calcListItems;

          return (
            <SwiperSlide key={index}>
              <Item key={index}>
                <ItemHead>
                  <span style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <span style={{ flexGrow: 1, textAlign: 'center', marginLeft: '15px' }}>{warrantyQuote ? <>Resumo da Contratação</> : <>Opção {index + 1}</>}</span>
                  </span>
                </ItemHead>

                <ItemBody>
                  <ItemSummary>
                    <div>
                      <Title>
                        {warrantyQuote ? 'Limite' : 'Importância Segurada'}
                        {!showAlterButton && <TitleAlter onClick={() => { history.push(`/edit-enquiry/${idProduct}/${idOperation}`) }}>Alterar</TitleAlter>}
                      </Title>
                      <SubTitle weight={700}>R$ {maskHelper.formatCurrency(authContext, coverageCalc.coverageLimit)}</SubTitle>
                    </div>
                    {hasCoverageCalc && <div>
                      <Title>
                        Franquia
                      </Title>
                      <SubTitle weight={700}>{coverageCalc.deductibleDescription}</SubTitle>
                    </div>}
                    {warrantyQuote && !permissions.NBI_REQUEST_APPROVE_REJECT ? null :
                      <>
                      <div>
                        <Title>
                          Prêmio NET
                        </Title>
                        <SubTitle>
                          R$ {maskHelper.formatCurrency(authContext, parseNumber(coverageCalc.coverageAmountDiscountLess))}
                        </SubTitle>
                      </div>
                      <div>
                        <Title>
                          Prêmio Líquido
                        </Title>
                        <SubTitle>
                          R$ {maskHelper.formatCurrency(authContext, parseNumber(coverageCalc.coverageAmountTaxLess))}
                        </SubTitle>
                      </div>
                      </>
                    }
                    <div>
                      <Title>
                        Prêmio Total (valor a ser pago)
                      </Title>
                      <SubTitle>
                        R$ {maskHelper.formatCurrency(authContext, parseNumber(coverageCalc.coverageAmount))}
                      </SubTitle>
                    </div>
                    {warrantyQuote && <>
                      <div>
                        <Title>
                          Limite Total do Tomador
                        </Title>
                        <SubTitle>
                          R$ {maskHelper.formatCurrency(authContext, borrowerCreditLimit?.limit || 0)}
                        </SubTitle>
                      </div>
                      <div>
                        <Title>
                          Limite Minutado do Tomador
                        </Title>
                        <SubTitle>
                          R$ {maskHelper.formatCurrency(authContext, borrowerCreditLimit?.limitDrafted || 0)}
                        </SubTitle>
                      </div>
                      <div>
                        <Title>
                          Limite Consumido do Tomador
                        </Title>
                        <SubTitle>
                          R$ {maskHelper.formatCurrency(authContext, borrowerCreditLimit?.limitConsumed || 0)}
                        </SubTitle>
                      </div>
                      <div>
                        <Title>
                          Limite Disponível do Tomador
                        </Title>
                        <SubTitle>
                          R$ {maskHelper.formatCurrency(authContext, borrowerCreditLimit?.availableLimit || 0)}
                        </SubTitle>
                      </div>

                      <div>
                        <Title>
                          Limite Total da Modalidade
                        </Title>
                        <SubTitle>
                          R$ {maskHelper.formatCurrency(authContext, modalityCreditLimit?.limit || 0)}
                        </SubTitle>
                      </div>
                      <div>
                        <Title>
                          Limite Minutado da Modalidade
                        </Title>
                        <SubTitle>
                          R$ {maskHelper.formatCurrency(authContext, modalityCreditLimit?.limitDrafted || 0)}
                        </SubTitle>
                      </div>
                      <div>
                        <Title>
                          Limite Consumido da Modalidade
                        </Title>
                        <SubTitle>
                          R$ {maskHelper.formatCurrency(authContext, modalityCreditLimit?.limitConsumed || 0)}
                        </SubTitle>
                      </div>
                      <div>
                        <Title>
                          Limite Disponível da Modalidade
                        </Title>
                        <SubTitle>
                          R$ {maskHelper.formatCurrency(authContext, modalityCreditLimit?.availableLimit || 0)}
                        </SubTitle>
                      </div>
                    </>}
                    
                    <div>
                      <Title>
                        Comissão
                      </Title>
                      <Field style={{ width: '100%'}}
                        name={`${formikKey}.${index}.coverageComissionRate`}
                        component={InputField}
                        disabled={(readOnlyMode || disabledCommision) || (!minComission && !maxComission)}
                        type="text"
                        alignCenter
                        mask={{
                          type: "percentage",
                          mask: '% num',
                          blocks: {
                            num: {
                              mask: Number,
                              scale: 5,
                              signed: false,
                              thousandsSeparator: '',
                              padFractionalZeros: true,
                              normalizeZeros: false,
                              radix: ".",
                              max: maxComission || 100,
                              min: minComission || 0
                            }
                          }
                        }}
                        onBlur={(value) => onRecalculate && onRecalculate(value / 100, index, 'customComissionRate')}
                      />
                    </div>
                    <div style={{ alignItems: 'flex-end'}}>
                      {/* <button>teste</button> */}
                      {!readOnlyMode && 
                     <Button
                        disabled={readOnlyMode || disabledConfirm || !permissions.MARKETS_SELECTION}
                        id="btnContinue"
                        type="button"
                        onClick={(e) => {
                          e.stopPropagation();
                          e.preventDefault();
                          onConfirmPlan && onConfirmPlan(index)
                        }}
                        secondary={!customButton}
                        custom={customButton}
                      >
                        {onConfirmPlanText}
                      </Button>
                      }
                    </div>
                    <div>

                  <Title>
                    {productPlanName}
                  </Title>
                    </div>
                  </ItemSummary>
                  <CoveragesContainer>
                    <ItemCoverageHead>
                      <Title
                        onClick={() => handleCollapseCoverages(index)}>
                        Coberturas
                        <Icon
                          style={{ cursor: "pointer", marginLeft: "5px" }}
                          name={Boolean(collapseCoverages[index]) ? "arrowdown" : "arrowup"}
                        />
                      </Title>
                      <HasPermission
                        permission={!readOnlyMode && permissions.NBI_REQUEST_APPROVE_REJECT}
                      >
                        <EditButton onClick={(e) => {
                          if (selectedOption != null) return;
                          // if (!permissions.NBI_REQUEST_APPROVE_REJECT) return;
                          e.stopPropagation();
                          showOption(index)
                          showOption(0)
                        }}>
                          {expanded ? "Voltar" : "Editar"}
                          {(showHistory) ?
                            <Icon name="icon-green_exclamation" className={'icon-green_exclamation'} style={{ textAlign: 'right', marginRight: '15px' }}
                              onClick={(e) => {
                                if (selectedOption != null) return;
                                e.stopPropagation();
                                openHistoryModel && openHistoryModel(index)
                              }} />
                            : <></>
                          }
                          {/* <Icon name="edit" style={{ textAlign: 'right' }} /> */}
                        </EditButton>
                      </HasPermission>
                    </ItemCoverageHead>
                      
                  <ItemCoverages isCollapse={collapseCoverages[index]}>
                    {coverage.map((coverages, covIndex) => {
                      const validation = (coverages.coverageDomain === 1 || readOnlyMode || !permissions.NBI_REQUEST_APPROVE_REJECT || newDisabled);
                      return <CoverageItem>
                        
                        <CoverageTitle>
                        {expanded && <Field
                            component={CheckBox}
                            name={`${formikKey}.${option}.coverageItems.${covIndex}.coverageDisabled`}
                            checked={!coverages.coverageDisabled}
                            checkValue
                            disabled={(!isInAnalysis && coverages.coverageDomain !== 1) ? false : validation}
                            reverseValue
                            onChange={(value) => {
                              handleCheckCoverage && handleCheckCoverage(value, option, coverages.idCoverage)
                            }}
                          />}
                          <Label>{coverages.coverageName}</Label>
                          {(!showCoveragesAndExtensions) && handleIcons(index, covIndex)}
                        </CoverageTitle>

                        <CoverageBody>
                          {(!showCoveragesAndExtensions) && <>
                              {formikValues?.calculationList[index].coverageItems[covIndex]?.coverageDisabled ?
                                <Field
                                  name={'defaultValueCoverageDisabled'}
                                  component={InputField}
                                  type="text"
                                  validation={false}
                                  disabled={true}
                                  readOnly={true}
                                  label={`PR. LÍQUIDO ${index + 1}`}
                                /> :
                                <Field
                                  mask={currencyMask()}
                                  name={`${formikKey}.${index}.coverageItems.${covIndex}.coveragePremiumTaxLess`}
                                  component={InputField}
                                  type="text"
                                  validation={false}
                                  disabled={readOnlyMode || !permissions.NBI_REQUEST_APPROVE_REJECT || disabled || formikValues?.calculationList[index].coverageItems[covIndex]?.coverageDisabled}
                                  readOnly={true}
                                  label={`PR. LÍQUIDO ${index + 1}`}
                                />
                              }
                              {expanded && (<>
                                {formikValues?.calculationList[index].coverageItems[covIndex]?.coverageDisabled ?
                                  <Field
                                    label={`PR. TÉCNICO`}
                                    name={'defaultValueCoverageDisabled'}
                                    component={InputField}
                                    type="text"
                                    validation={false}
                                    disabled={true}
                                    readOnly={true}
                                  /> :
                                  <Field
                                    label={`PR. TÉCNICO`}
                                    mask={currencyMask()}
                                    name={`${formikKey}.${index}.coverageItems.${covIndex}.coveragePremium`}
                                    component={InputField}
                                    type="text"
                                    validation={false}
                                    disabled={readOnlyMode || !permissions.NBI_REQUEST_APPROVE_REJECT || disabled || formikValues?.calculationList[index].coverageItems[covIndex]?.coverageDisabled}
                                    readOnly={true}
                                  />
                                }
                              </>)}
                              {expanded && (<>
                                {formikValues?.calculationList[index].coverageItems[covIndex]?.coverageDisabled ?
                                  <Field
                                    label={`AJUSTE %`}
                                    name={'defaultValueCoverageDisabled'}
                                    component={InputField}
                                    type="text"
                                    validation={false}
                                    disabled={true}
                                    readOnly={true}
                                  /> :
                                  <Field
                                    label={`AJUSTE %`}
                                    name={`${formikKey}.${index}.coverageItems.${covIndex}.coveragePremiumDiscountRate`}
                                    component={InputField}
                                    type="text"
                                    validation={false}
                                    mask={idProduct == 34 ? maskHelper.getPercentage(authContext.region, 6, "5000.000000", "-5000.000000") : maskHelper.getPercentage(authContext.region, 2, "1000", "-100")}
                                    disabled={readOnlyMode || !permissions.NBI_REQUEST_APPROVE_REJECT || disabled || formikValues?.calculationList[index].coverageItems[covIndex]?.coverageDisabled}
                                    onBlur={(value) => onRecalculate && onRecalculate(value / 100, index, 'customCoveragePremiumDiscountRate')}
                                  />
                                }
                              </>)}
                              {expanded && (<>
                                {formikValues?.calculationList[index].coverageItems[covIndex]?.coverageDisabled ?
                                  <Field
                                    label={`PR. TÉCNICO AJUSTADO`}
                                    name={'defaultValueCoverageDisabled'}
                                    component={InputField}
                                    type="text"
                                    validation={false}
                                    disabled={true}
                                    readOnly={true}
                                  /> :
                                  <Field
                                    label={`PR. TÉCNICO AJUSTADO`}
                                    mask={currencyMask()}
                                    name={`${formikKey}.${index}.coverageItems.${covIndex}.coveragePremiumDiscountLess`}
                                    component={InputField}
                                    type="text"
                                    validation={false}
                                    disabled={readOnlyMode || !permissions.NBI_REQUEST_APPROVE_REJECT || disabled || formikValues?.calculationList[index].coverageItems[covIndex]?.coverageDisabled}
                                    readOnly={true}
                                  />
                                }
                              </>)}
                              {expanded && (<>
                                <Label>
                                  SUBLIMITE
                                </Label>

                                <RowValue>
                                  <RowValue style={{ width: '45px', margin: '0', padding: '0', marginRight: '10px' }}>
                                    <Label style={{ margin: '0', padding: '0' }}>%</Label>
                                    <Field
                                      style={{ padding: '0', margin: "0", paddingLeft: '5px' }}
                                      component={CheckBox}
                                      name={`${formikKey}.${option}.coverageItems.${covIndex}.showCoverageMaxLimClaimRate`}
                                      checked={formikValues?.calculationList[index].coverageItems[covIndex].showCoverageMaxLimClaimRate}
                                      checkValue
                                      disabled={readOnlyMode || !permissions.NBI_REQUEST_APPROVE_REJECT || disabled || formikValues?.calculationList[index].coverageItems[covIndex]?.coverageDisabled}
                                      onChange={(value) => onRecalculateItem && onRecalculateItem(value, index, coverages.idCoverage, 'showCoverageMaxLimClaimRate')}
                                    />
                                  </RowValue>

                                  {formikValues?.calculationList[index].coverageItems[covIndex]?.coverageDisabled ?
                                    <Field
                                      style={{ width: '100%', margin: '0' }}
                                      name={'defaultValueCoverageDisabled'}
                                      component={InputField}
                                      type="text"
                                      validation={false}
                                      disabled={true}
                                      readOnly={true}
                                    /> : formikValues?.calculationList[index].coverageItems[covIndex].showCoverageMaxLimClaimRate ?
                                      <Field
                                        style={{ width: '100%', margin: '0' }}
                                        name={`${formikKey}.${index}.coverageItems.${covIndex}.coverageMaxLimClaimRate`}
                                        component={InputField}
                                        type="text"
                                        validation={false}
                                        mask={maskHelper.getPercentage(authContext.region, 2, "100", "0")}
                                        disabled={readOnlyMode || !permissions.NBI_REQUEST_APPROVE_REJECT || disabled || formikValues?.calculationList[index].coverageItems[covIndex]?.coverageDisabled}
                                        onBlur={(value) => onRecalculate && onRecalculateItem(value / 100, index, coverages.idCoverage, 'coverageMaxLimClaimRate', 'coverageMaxLimClaim')}
                                      /> :
                                      <Field
                                        style={{ width: '100%', margin: '0' }}
                                        mask={currencyMask(formikValues?.calculationList[index].coverageItems[covIndex].coverageLimit)}
                                        name={`${formikKey}.${index}.coverageItems.${covIndex}.coverageMaxLimClaim`}
                                        component={InputField}
                                        type="text"
                                        validation={false}
                                        disabled={readOnlyMode || !permissions.NBI_REQUEST_APPROVE_REJECT || disabled || formikValues?.calculationList[index].coverageItems[covIndex]?.coverageDisabled}
                                        onBlur={(value) => onRecalculateItem && onRecalculateItem(value, index, coverages.idCoverage, 'coverageMaxLimClaim', 'coverageMaxLimClaimRate')}
                                      />
                                  }
                                </RowValue>
                              </>)}
                            </>}
                        </CoverageBody>

                      </CoverageItem>
                    })}
                  </ItemCoverages>
                  </CoveragesContainer>
                </ItemBody>
              </Item>
            </SwiperSlide>
          );
        })}
      </Swiper>
      </Carrossel>
      {warrantyQuote ? <ExtraText>* Poderá sofrer alteração durante a análise de risco</ExtraText> : null}
      
    </Container>
  )
}

export default MobileTable;
